module.exports = fox._r("fonts/montserrat-hairline-webfont.ttf", __webpack_public_path__ + "fonts/3kTksFZ.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/montserrat-hairline-webfont.ttf
// module id = 4
// module chunks = 5